const ePosta = (value, message) => {
    if (!value) {
        return null
    }

    //eslint-disable-next-line
    const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (!pattern.test(value)) {
        return message ?? "Lütfen e-posta adresinizi kontrol edin.";
    }

    return null
}

export default ePosta